import React from 'react';
import HeaderNav from '../HeaderNav/HeaderNav';
import { Tabs } from '../Tabs/Tabs';
import { Heading, Text, useTheme, VStack } from 'native-base';
import { useNavigate } from 'react-router-dom';

const routes = [
  {
    key: 'first',
    path: '/settings/personal-info',
    title: 'PERSONAL INFORMATION',
  },
  {
    key: 'second',
    path: '/settings/diet',
    title: 'HEALTH & DIET',
  },
  {
    key: 'third',
    path: '/settings/subscription',
    title: 'SUBSCRIPTION & BILLING',
  },
  {
    key: 'fourth',
    path: '/settings/notifications',
    title: 'NOTIFICATIONS',
  },
  {
    key: 'fifth',
    path: '/settings/about',
    title: 'ABOUT',
  },
];

export const SettingsPage = () => {
  const {
    colors: { muted },
  } = useTheme();
  const navigate = useNavigate();

  return (
    <div
      className="settings-page"
      style={{
        height: '100vh',
        overflow: 'auto',
        backgroundColor: muted['50'],
      }}
    >
      <HeaderNav page={1} changePage={() => navigate(-1)} />
      <div style={{ margin: '0 auto', maxWidth: '1048px' }}>
        <VStack p={6}>
          <Heading color="black" pb={2} textAlign="left" size="xl">
            My Account
          </Heading>
          <Text color="black" pb={8} fontSize="lg" fontWeight="normal">
            Update any of your account information here.
          </Text>
          <Tabs indexRoute={routes[0].path} routes={routes} />
        </VStack>
      </div>
    </div>
  );
};
